import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const MainWithSidebarTemplate = props => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("link", {
      rel: "stylesheet",
      href: "https://static2.sharepointonline.com/files/fabric/office-ui-fabric-core/10.0.0/css/fabric.min.css"
    }), props.breadCrumb, /*#__PURE__*/_jsx("div", {
      className: "ms-motion-slideLeftIn",
      children: props.header
    }), /*#__PURE__*/_jsx("div", {
      className: "ms-Grid",
      dir: "ltr",
      children: /*#__PURE__*/_jsxs("div", {
        className: "ms-Grid-row",
        children: [/*#__PURE__*/_jsx("div", {
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg3 ms-xxl2 ms-motion-slideRightIn",
          children: props.offSide
        }), /*#__PURE__*/_jsx("div", {
          className: "ms-Grid-col ms-sm6 ms-md8 ms-lg9 ms-xxl10 ms-motion-slideLeftIn",
          children: props.main
        })]
      })
    })]
  });
};